import {
  Transaction,
  TransactionContextProvider,
  TransactionDetailsAPIProvider,
  TransactionListItem,
  TransactionOrWithdrawal,
} from "ui/merchant";

import useAPI from "@/src/contexts/api-context";

type Props = {
  uuid: string;
};

export default function TransactionDetails({ uuid }: Props) {
  const { apiClient } = useAPI();

  async function getTx() {
    const { data } = await apiClient.get<TransactionOrWithdrawal>(
      `/transactions/${uuid}`
    );

    console.log(data);
    return data;
  }

  return (
    <TransactionDetailsAPIProvider
      getTransaction={getTx}
      getTransactionSummary={stub(summary)}
      patchTransaction={log}
      onSelectCartItem={log}
      onEditBankPress={log}
      onWhatsappHelpPress={log}
      onErrorClose={log}
      cancelPayment={log}
      markAsReadyForPickup={log}
      markAsDelivered={log}
      markAsPaid={log}
      copyToClipboard={log}
      shareMessage={stub(true)}
      resendReceipt={log}
      resendRefundReceipt={log}
      resendPaymentInstructions={log}
      withdrawBanks={[]}
    >
      <TransactionContextProvider uuid={uuid}>
        <Transaction />
      </TransactionContextProvider>
    </TransactionDetailsAPIProvider>
  );
}

async function log<T>(data?: T) {
  data && console.log(data);
}

function stub<T>(data: T): () => Promise<T> {
  return async () => data;
}

const summary: TransactionListItem = {
  icon: "credit-card-outline",
  label: "Felipe Echandi",
  amount: 100,
  currency: "usd",
  statuses: [
    {
      text: "Pagada",
      completed: true,
    },
    {
      text: "Por entregar",
      completed: false,
    },
  ],
  uuid: "c7d1b5dd-e9e4-4afe-969a-dc40374318f8",
  created_at: "2023-08-31T16:09:35.236-05:00",
  pending: true,
  simple_order_id: null,
  read: true,
};
